import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';

export function NotFound() {
    return <ContentBox title="Page Not Found">There was a problem loading the page.</ContentBox>;
}
